import * as React from 'react';
import '../UpdateProject.css';

export interface ProjectRoundInformationSidebarComponentProps {
  section: string;
  handleClick: (value: string) => void;
}

class ProjectRoundInformationSidebarComponent
  extends React.PureComponent<ProjectRoundInformationSidebarComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="edit-project-sidebar border-right-inset-shadow text-right padding-l-r-0">
        <ul className="sidebar-project sidebar-project-preview">
          <li
            key="summary"
            className={this.props.section === 'resumen' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('resumen')}
          >

            <span className="resume"/> Resumen
          </li>
          <li
            key="business-model"
            className={this.props.section === 'business-model' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('modelo-de-negocio')}
          >
            <span className="go"/> Modelo de negocio
          </li>
          <li
            key="market"
            className={this.props.section === 'mercado' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('mercado')}
          >
            <span className="market"/> Mercado
          </li>
          <li
            key="metrics"
            className={this.props.section === 'metricas' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('metricas')}
          >
            <span className="metrics"/> Métricas
          </li>
          <li
            key="financial-data"
            className={this.props.section === 'financial-data' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('datos-financieros')}
          >
            <span className="environment"/> Datos financieros
          </li>
          <li
            key="details"
            className={this.props.section === 'detalles' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('detalles')}
          >
            <span className="details"/> Detalles de la ronda
          </li>
          <li
            key="team"
            className={this.props.section === 'equipo' ?
              'active' :
              ''
            }
            onClick={() => this.props.handleClick('equipo')}
          >
            <span className="team"/> Equipo
          </li>
          <li
            key="docs"
            className={this.props.section === 'documentos' ?
              'active' :
              'hidden'
            }
            onClick={() => this.props.handleClick('documentos')}
          >
            <span className="docs"/> Documentos
          </li>
        </ul>
      </div>
    );
  }
}

export default ProjectRoundInformationSidebarComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectRoundInformationSidebar.component.tsx